import { faGithub, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faKey, type IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { CircularProgress } from '../circular-progress';

type IconType = 'google' | 'github' | 'envelope' | 'key';

const icons: Record<IconType, IconDefinition> = {
  google: faGoogle,
  github: faGithub,
  envelope: faEnvelope,
  key: faKey,
};

type Props = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  icon: IconType;
  loading?: boolean;
};

const hoverBgColors: Record<IconType, string> = {
  google: 'group-hover:text-[#EA4335]',
  github: 'group-hover:text-[#24292e]',
  envelope: 'group-hover:text-[#FBBC05]',
  key: 'group-hover:text-primary',
};

export const AuthOption = ({ icon, loading, ...buttonProps }: Props) => {
  return (
    <button
      disabled={buttonProps.disabled}
      type={buttonProps.type}
      name={buttonProps.name}
      value={buttonProps.value}
      className={twMerge(
        'group flex h-11 w-full cursor-pointer items-center overflow-hidden rounded border border-gray-300',
        buttonProps.disabled ? 'opacity-50' : 'hover:bg-gray-200',
      )}
      onClick={buttonProps.onClick}
    >
      <div className="flex h-full w-11 items-center justify-center border-r border-gray-300 bg-white">
        <FontAwesomeIcon icon={icons[icon]} className={twMerge('h-5 w-5 text-gray-400', hoverBgColors[icon])} />
      </div>
      <span className="pl-2 text-[14px]">{buttonProps.children}</span>
      {loading && (
        <div className="flex flex-grow justify-end pl-2 pr-2">
          <CircularProgress />
        </div>
      )}
    </button>
  );
};

export const Header = ({ children }: { children: ReactNode }) => {
  return <p className="m-0 pb-[8px] pt-[24px] text-center text-md font-medium text-gray-800">{children}</p>;
};

export const Footer = ({ children }: { children: ReactNode }) => {
  return <p className="m-0 text-center text-[14px] font-normal text-gray-500">{children}</p>;
};

export const Tail = ({ children }: { children: ReactNode }) => {
  return <div className="absolute bottom-[-32px] left-0 flex w-full justify-center">{children}</div>;
};
